import {
  XAxis,
  AreaChart,
  Area,
  Tooltip,
  ResponsiveContainer,
  LineChart,
  YAxis,
  CartesianGrid,
} from "recharts";
import ReportHelper from "@/app/core/util/helpers/ReportHelper";
import React, { useEffect, useState } from "react";
import { DateHelper } from "@/app/core/util/helpers/DateHelper";
import { PropertiesController } from "@/app/core/base/controllers/PropertiesController";

export default function AdsReport({}) {
  const date = new Date();
  const [data, setData] = useState({ total: 0, ticket: 0, count: 0 });
  const [startDate, setStartDate] = useState(
    DateHelper.GetFirstDayOfMonth(date.getFullYear(), 0)
  );
  const [endDate, setEndDate] = useState(
    DateHelper.GetLastDayOfMonth(date.getFullYear(), 11)
  );
  const reportHelper = ReportHelper();

  useEffect(() => {
    loadReport();
  }, [startDate, endDate]);

  async function loadReport() {
    const reports = await PropertiesController.GetAdminReportsByDate(
      startDate,
      endDate
    );

    process(reports);
  }

  function process(res) {
    let responses = reportHelper.base;

    for (let s in responses) {
      for (let i in res) {
        if (res[i].month === responses[s].value) {
          responses[s].aluguel = parseInt(res[i].aluguel);
          responses[s].venda = parseInt(res[i].venda);
        }
      }
    }
    console.log("Tickets", responses);
    setData(responses);
  }

  function processDate(year) {
    setStartDate(DateHelper.GetFirstDayOfMonth(year, 0));
    setEndDate(DateHelper.GetLastDayOfMonth(year, 11));
  }

  return (
    <div className="col-md-12" key={"ticketsReport"}>
      <div className="block block-rounded block-bordered">
        <ul className="nav nav-tabs nav-tabs-block align-items-center border-bottom">
          <li className="nav-item">
            <a
              className="nav-link text-body-color active"
              href="javascript:void(0)"
            >
              Tipos de anúncios
            </a>
          </li>

          <li className="nav-item ml-auto">
            <div className="block-options mr-3">
              <button
                className="btn btn-dual"
                onClick={() => processDate(date.getFullYear() - 2)}
              >
                {date.getFullYear() - 2}
              </button>
              <button
                className="btn btn-dual"
                onClick={() => processDate(date.getFullYear() - 1)}
              >
                {date.getFullYear() - 1}
              </button>
              <button
                className="btn btn-dual"
                onClick={() => processDate(date.getFullYear())}
              >
                {date.getFullYear()}
              </button>
            </div>
          </li>
        </ul>
        {data && data ? (
          <div className="block-content block-content-full">
            <ResponsiveContainer height={300} key={"aluguel"}>
              <AreaChart
                width={400}
                height={400}
                data={data}
                margin={{ top: 5, right: 20, left: 10, bottom: 5 }}
              >
                <XAxis dataKey="name" />
                <Tooltip />
                <Area
                  type="monotone"
                  dataKey={"aluguel"}
                  stroke={reportHelper.colors[4]}
                  fill={reportHelper.colors[4]}
                />
                <Area
                  type="monotone"
                  dataKey={"venda"}
                  stroke={reportHelper.colors[3]}
                  fill={reportHelper.colors[3]}
                />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}
